<ng-container *ngFor="let section of schema; let i = index;">
  <ng-container [ngSwitch]="section.type" *ngIf="visibility[i].visible">
    <div class="section" 
      [class]="section.size || ''"
      [ngClass]="section.customClass"
      [ngStyle]="section.customStyle">

      <ng-container *ngSwitchCase="'info'">
        <div class="message warn" *ngIf="!section.hideLabel" [ngStyle]="section.customStyle">{{ section.label }}</div>
      </ng-container>

      <ng-container *ngSwitchCase="'custom'">
        <ng-container [ngSwitch]="section.customType">
          <ng-container *ngSwitchCase="'list-form'">
            <app-list-subform-lock  
              [fieldControl]="section.fieldControl | asFormControl"
              [formConfig]="section.customFieldData"
              [readOnly]="section.readOnly">
            </app-list-subform-lock>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</ng-container>